import { createContext, useMemo, useState, useEffect } from "react";
import { useContext } from "react";
import { useGetAllMerchantNotifications } from "../api/services/notificationService";

const NotificationContext = createContext();

const NotificationContextProvider = ({ children }) => {
  const {
    data,
    isPending,
    error,
    refetch,
  } = useGetAllMerchantNotifications();

  const apiNotifications = data?.data || [];

  const [realtimeNotifications, setRealtimeNotifications] = useState([]);

  const saveNotification = (notification) => {
    setRealtimeNotifications((prev) => [
      { ...notification, isRead: false, timestamp: new Date().toISOString() },
      ...prev,
    ]);
    refetch();
  };

  useEffect(() => {
    setRealtimeNotifications([]);
  }, []);

  const notifications = useMemo(() => {
    const seen = new Set();
    const merged = [];
    for (const n of [...realtimeNotifications, ...apiNotifications]) {
      const key = n.id || n.message;
      if (!seen.has(key)) {
        seen.add(key);
        merged.push(n);
      }
    }
    return merged;
  }, [realtimeNotifications, apiNotifications]);

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  const markAsRead = (notificationId) => {
    refetch();
  };
  const markAllAsRead = () => {
    refetch();
  };

  const values = useMemo(() => ({
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
    isPending,
    error,
    refetch,
    saveNotification,
  }), [notifications, unreadCount, isPending, error]);

  return (
    <NotificationContext.Provider value={values}>
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationContextProvider };
